<template>
  <div class="research-projects-search dmd-dropdown">
    <fieldset class="options-dropdown-facet">
      <legend>
        <button
          ref="button"
          class="tag-selection-toggle-button dmd-tag-selection-toggle-button"
          type="button"
          id="toggle-btn-research"
          aria-controls="target-selection-box"
          :aria-expanded="expanded"
          @click="expanded = !expanded"
        >
          {{ title }} <span class="option">{{ optionTitle }}</span>
          <i class="icon-chevron-down" aria-hidden="true"></i>
        </button>
      </legend>
      <div
        class="options-dropdown-facet__checkboxes"
        id="target-selection-box-research"
        :aria-hidden="!expanded"
        aria-labelledby="toggle-btn"
        @click="expanded = !expanded"
        :class="{ active: expanded }"
      >
        <div class="checkbox" v-for="option in options" :key="option.id">
          <label>
            <input
              type="radio"
              :name="name"
              :value="option.id"
              v-model="value"
            />

            <span class="checkmark" aria-hidden="true"></span>
            {{ option.title }}
          </label>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {
      expanded: false,
      value: null,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    name: {
      type: String,
      default: "",
      required: true,
    },
    init: {
      type: String,
      default: "score",
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  watch: {
    value(newValue) {
      this.$emit("change", newValue);
    },
  },
  computed: {
    optionTitle() {
      const option = this.options.find((option) => option.id === this.value);
      return option ? option.title : "";
    },
  },
  created() {
    if (this.init) {
      this.value = this.init;
    } else {
      this.value = this.options[0].id;
    }
  },
  mounted() {
    window.addEventListener("click", (event) => {
      const target = event.target;
      if (this.expanded && target !== this.$refs.button) {
        this.expanded = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.dmd-dropdown {
  margin: 0;

  .option {
    margin-left: 5px;
  }

  fieldset {
    margin: 0;

    .dmd-tag-selection-toggle-button {
      justify-content: unset;
    }

    legend {
      margin: 0;

      button {
        font-size: 20px;
        font-weight: normal;

        span {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
